module.exports = __webpack_public_path__ + "static/media/nothingfound@2x.d9f2d5b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nothingfound@2x.png
// module id = 354
// module chunks = 0